// hooks
import {
  DefaultError,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";

// utilities
import { asyncActionsClient } from "../contexts/react-query/query-client";

/**
 * check that to see if Access Control is met for acl or schema
 * the `acl` is provided that will take precedent over schemaId
 */
export function useAsyncAction<
  TQueryFnData = unknown,
  TError = DefaultError,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(props: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>) {
  return useQuery<TQueryFnData, TError, TData, TQueryKey>(
    {
      ...props,
    },
    asyncActionsClient,
  );
}
